import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const BOX = {
    display: "inline-flex",
    alignItems: "center",
    gap: "var(--space-075)",
    minHeight: "var(--space-3)",
    fontSize: "var(--type-evidence-size)",
    lineHeight: "var(--type-evidence-line)",
    letterSpacing: "var(--type-evidence-tracking)",
    fontVariantNumeric: "tabular-nums",
    whiteSpace: "nowrap",
};
const GLYPH = (_jsx("svg", { width: 10, height: 10, viewBox: "0 0 10 10", "aria-hidden": "true", style: { flex: "none" }, children: _jsx("path", { d: "M2 1.2 9 5 2 8.8z", style: { fill: "currentColor" } }) }));
const LIVE = {
    ...BOX,
    margin: 0, padding: 0, border: "none", background: "transparent", cursor: "pointer",
    fontFamily: "var(--font-sans)", fontWeight: "var(--type-evidence-weight)",
    color: "var(--accent)", borderRadius: "var(--radius-inline)",
};
export function EvidenceLink({ time, onSeek, href, label, off = false, keepGlyph = false, ...hooks }) {
    if (off) {
        return (_jsxs("span", { "data-evidence": "off", ...hooks, style: { ...BOX, color: "var(--ink-2)", fontWeight: "var(--type-body-weight-strong)" }, children: [keepGlyph && GLYPH, time] }));
    }
    const name = label ?? `Jump to ${time}`;
    const body = (_jsxs(_Fragment, { children: [GLYPH, _jsx("span", { "data-evidence-time": "", style: {
                    paddingBottom: "var(--space-025)",
                    borderBottom: "var(--border-hairline) solid var(--evidence-underline, var(--accent-line))",
                    transitionProperty: "border-color",
                    transitionDuration: "var(--dur-fast)",
                    transitionTimingFunction: "var(--ease-out)",
                }, children: time })] }));
    if (href !== undefined) {
        return (_jsx("a", { href: href, target: "_blank", rel: "noopener noreferrer", "data-evidence": "", "aria-label": name, title: name, ...hooks, style: { ...LIVE, textDecoration: "none" }, children: body }));
    }
    return (_jsx("button", { type: "button", "data-evidence": "", "aria-label": name, ...hooks, onClick: onSeek, style: LIVE, children: body }));
}
